module.exports = __webpack_public_path__ + "static/media/imagene.caca7f62.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pdf/imagene.pdf
// module id = 313
// module chunks = 0